export default __webpack_public_path__ + "static/media/hht2_ep7_speaking_02.dd2b6cb8.png";